import React from 'react';
import cx from 'classnames';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { Tabs as ArcoTabs } from '@m4b-design/components';
import { TAB_TOP_ID } from '@/pages/Homepage/constants';
import { AnchorTo } from '@/pages/Homepage/components';
import { TabTitle } from './TabTitle';
import { useTabs } from './index.ViewHook';
import styles from './index.scss';

export const Tabs = () => {
  const [failedTabs, setFailedTabs] = React.useState<string[]>([]);
  const { t } = useTranslation();
  const {
    ref,
    inView,
    active,
    list,
    tabs,
    doesNeedToShowCourseTab,
    tabChangeHandle,
  } = useTabs();
  const tabsToShow = tabs.filter(key => !failedTabs.includes(key));
  if (!tabsToShow.includes(active)) {
    tabChangeHandle(tabsToShow[0]);
  }
  const noCourseClass = tabsToShow.includes('course') ? '' : styles.NoCourse;

  return (
    <div>
      <ul
        className={cx(styles.TabsPaneFixed, {
          [styles.TabsNotInView]: !inView,
          [styles.TabsNotCourse]: !doesNeedToShowCourseTab,
        })}>
        {tabsToShow.map(
          key =>
            list[key].title && (
              <li
                key={key}
                className={cx({
                  active: key === active,
                })}
                onClick={() => tabChangeHandle(key)}>
                <AnchorTo anchor={TAB_TOP_ID} />
                {t(list[key].title)}
              </li>
            ),
        )}
      </ul>
      <div
        className={cx(styles.Tabs, {
          [styles.TabsNotCourse]: !doesNeedToShowCourseTab,
        })}>
        {!inView && <div className={styles.TabsTop} id={TAB_TOP_ID} />}
        <ArcoTabs
          className={styles.TabsPane}
          type="text"
          animation={false}
          headerPadding={false}
          lazyload={true}
          activeTab={active}
          onChange={tabChangeHandle}
          renderTabHeader={(props, DefaultTabHeader) => (
            <div className={styles.TabsHeader}>
              <span ref={ref} />
              <DefaultTabHeader {...props} />
            </div>
          )}>
          {tabsToShow.map(tab => {
            const { key, Content, title, desc, ...tabTitle } = list[tab];
            return (
              title && (
                <ArcoTabs.TabPane
                  key={key}
                  title={
                    <TabTitle
                      icon={<div data-tab={key} className={styles.TabsIcon} />}
                      title={t(title)}
                      desc={t(desc)}
                      {...tabTitle}
                      className={noCourseClass}
                    />
                  }>
                  <Content
                    handleError={() => setFailedTabs(curr => [...curr, key])}
                  />
                </ArcoTabs.TabPane>
              )
            );
          })}
        </ArcoTabs>
      </div>
    </div>
  );
};
